'use client'

import { Image } from '@vinted/web-ui'

import { useAsset } from '@marketplace-web/shared/assets'

const SellerProtectionImage = () => {
  const asset = useAsset('/assets/verifications/add-phone-number')

  return (
    <Image
      src={asset('shield-phone-girl.svg')}
      size={Image.Size.X4Large}
      scaling={Image.Scaling.Contain}
      testId="seller-protection-image"
    />
  )
}

export default SellerProtectionImage
